import { Add, Close, Delete, DragIndicator, Edit, ExpandMore, Info, MoreVert, Search, Visibility } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Button,
    capitalize,
    Checkbox,
    Chip,
    CircularProgress,
    debounce,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    ListItemIcon,
    Menu,
    MenuItem,
    OutlinedInput,
    Stack,
    styled,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Tabs,
    Tooltip,
    tooltipClasses,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../App';
import emptyInventory from '../../assets/emptyInventory.png';
import CommonDialog from '../../common/CommonDialog';
import { activeTableSortLabel } from '../../config/MaterialUIConstants';
import {
    deleteInventoryApi,
    getInventoryListApi,
    getPartNameForINventory,
    getPartNumberForINventory,
    getPartsBrandForINventory,
    getPartsCatgeoryForINventory,
    getTireDimensionForINventory,
    getTyreModelForINventory,
} from '../../redux/Inventory/action';
import { getSupplierListApi } from '../../redux/Supplier/action';
import { INVENTORY_MANAGE_TYPE, INVENTORY_STATUS, INVENTORY_TYPES, PART_TYPES, PARTS_STATUS, TableRowsLoader } from '../../utility/Constant';
import { NumericEngine } from '../../utility/helpers/numericEngine';
import PartUsedInvoiceModal from '../Suppliers/SupplierInvoice/PartUsedInvoiceModal';
import AddInventoryModal from './AddInventory';
import PartDetailsModal from './PartDetailTable';

// Accessibility props for tab panel
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Custom Tab Panel component
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const sortArray = [
    { key: 'createdAt', orderBy: 'DESC' },
    { key: 'partNumber', orderBy: 'DESC' },
    { key: 'part', orderBy: 'DESC' },
    { key: 'supplier', orderBy: 'DESC' },
    { key: 'partsBrand', orderBy: 'DESC' },
    { key: 'partsCategory', orderBy: 'DESC' },

    { key: 'dimensions', orderBy: 'DESC' },
    { key: 'tyreModel', orderBy: 'DESC' },
];

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        // slotProps={{
        //   popper: {
        //     modifiers: [
        //       {
        //         name: "offset",
        //         options: {
        //           offset: [0, -12],
        //         },
        //       },
        //     ],
        //   },
        // }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#DFDFDF',
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.08)',
        color: 'rgba(0, 0, 0, 0.87)',
        width: 230,
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '-0.3%',
        padding: '12px',
        lineHeight: '100%',
        borderRadius: '12px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#DFDFDF', // Same as tooltip background color
    },
}));

// Inventory Component
const Inventory = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isOpenSideBar } = React.useContext(Context);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const tabIndices = [0, 1, 2]; // Indexes for tabs
    const pathSegments = window.location.pathname.split('/');
    const currentPage = pathSegments[pathSegments.length - 1];
    const [type, setType] = useState(PART_TYPES.PARTS);
    console.log('🚀 ~ Inventory ~ type:', type);
    const [openInventoryModel, setOpenInventoryModal] = useState(false);

    const [isAddPartAgain, setIsAddPartAgain] = useState(false);

    const [customerInvoices, setCustomerInvoices] = useState([]);
    const [partInvoiceModal, setPartInvoiceModal] = useState(false);

    // Get current page from URL
    const getCurrentPage = () => {
        const path = window.location.pathname;
        if (path.includes('all')) return '';
        if (path.includes('parts')) return PART_TYPES.PARTS;
        if (path.includes('tires')) return PART_TYPES.TYRE;
        return '';
    };

    const currentPageStatus = getCurrentPage();

    const [anchorEl, setAnchorEl] = useState(null);
    const open1 = Boolean(anchorEl);

    const [anchorElCategory, setAnchorElCategory] = useState(null);
    const openCategory = Boolean(anchorElCategory);

    const [anchorElTireModal, setAnchorElTireModal] = useState(null);
    const openTireModal = Boolean(anchorElTireModal);
    const [anchorElBrand, setAnchorElBrand] = useState(null);
    const openBrand = Boolean(anchorElBrand);

    const [anchorElSupplier, setAnchorElSupplier] = useState(null);
    const openSupplier = Boolean(anchorElSupplier);

    const [anchorElDimensions, setAnchorElDimensions] = useState(null);
    const openDimensions = Boolean(anchorElDimensions);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [value, setValue] = useState(0);
    const [tabsOrder, setTabsOrder] = useState([
        { id: 'all', label: 'ALL', index: 0 },
        { id: 'parts', label: 'PARTS', index: 1 },
        { id: 'tires', label: 'TIRES', index: 2 },
    ]);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const [sortParams, setSortParams] = useState(sortArray);

    const [searchValue, setSearchValue] = useState('');

    const [partCategoryArray, setPartCategoryArray] = useState([]);
    const [tireModalArray, setTireModalArray] = useState([]);
    const [partBrandArray, setPartBrandArray] = useState([]);
    const [supplierArray, setSupplierArray] = useState([]);
    const [tireDimensionArray, setTireDimensionArray] = useState([]);
    const [selectStatus, setSelectStatus] = useState('');

    const activeFilterCount = [
        partCategoryArray.length,
        partBrandArray.length,
        tireModalArray.length,
        supplierArray.length,
        tireDimensionArray.length,
        selectStatus ? 1 : 0,
    ].filter((count) => count > 0).length;

    const showClearFilterButton = activeFilterCount > 0;
    const clearFilterLabel = activeFilterCount > 1 ? 'Clear Filters' : 'Clear Filter';

    const [inventoryList, setInventoryList] = useState([]);

    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [inventoryDetail, setInventoryDetail] = useState(null);
    const [openPartDetailModal, setOpenPartDetailModal] = useState(false);

    const [showLoader, setShowLoader] = useState(true);
    const [open, setOpen] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [batchNumber, setBatchNumber] = useState(null);

    const inventoryPartName = useSelector((state) => state?.inventory?.inventoryPartName?.data) || [];

    const inventoryTyreDimension = useSelector((state) => state?.inventory?.inventoryTyreDimension?.data) || [];

    const inventoryPartsCategory = useSelector((state) => state?.inventory?.inventoryPartsCategory?.data) || [];
    const inventoryPartsBrand = useSelector((state) => state?.inventory?.inventoryPartsBrand?.data) || [];

    const inventoryTyreModel = useSelector((state) => state?.inventory?.inventoryTyreModel?.data) || [];
    console.log('🚀 ~ Inventory ~ inventoryTyreModel:', inventoryTyreModel);

    const partsList = useSelector((state) => state?.inventory?.partsList?.data);

    const partsBrandList = useSelector((state) => state?.inventory?.partsBrandList?.data);
    const partsCategoryList = useSelector((state) => state?.inventory?.partsCategoryList?.data);
    const supplierList = useSelector((state) => state?.supplier?.supplierData?.data);

    const fetchInventory = useCallback(async () => {
        setShowLoader(true);

        const payload = {
            partsType: currentPageStatus,
            search: searchValue,
            pagination: true,
            limit: rowsPerPage,
            page: page + 1,
            sort: decodeURIComponent(JSON.stringify(sortParams)), // Add sorting parameters
            inventoryType: INVENTORY_MANAGE_TYPE.MANAGED,
        };

        if (selectStatus && selectStatus !== '') {
            payload.partStatus = selectStatus;
        }

        // if (selectPartId && selectPartId !== "") {
        //   payload.partName = selectPartId;
        // }

        const response = await dispatch(getInventoryListApi(payload, partCategoryArray, partBrandArray, supplierArray, tireDimensionArray, tireModalArray));
        setInventoryList(response?.data?.length > 0 ? response.data : []);
        setTotalCount(response?.totalCount ?? 0);
        setShowLoader(false);
    }, [
        dispatch,
        searchValue,
        page,
        rowsPerPage,
        selectStatus,
        partCategoryArray,
        tireDimensionArray,
        partBrandArray,
        supplierArray,
        sortParams,
        currentPageStatus,
        tireModalArray,
    ]);

    useEffect(() => {
        // Find the tab index based on the current page
        const tabIndex = tabsOrder.findIndex((tab) => {
            if (currentPageStatus === '' && tab.id === 'all') return true;
            if (currentPageStatus === PART_TYPES.PARTS && tab.id === 'parts') return true;
            if (currentPageStatus === PART_TYPES.TYRE && tab.id === 'tires') return true;
            return false;
        });

        if (tabIndex !== -1) {
            setValue(tabIndex);
        }

        // Fetch data based on tab
        fetchApiWithTabChange();
    }, [currentPageStatus, tabsOrder]);

    useEffect(() => {
        fetchInventory();
    }, [fetchInventory]);

    useEffect(() => {
        fetchAllFilterApi();
    }, []);

    const fetchApiWithTabChange = async () => {
        const params = { partsType: currentPageStatus };
        await dispatch(getPartNameForINventory(currentPageStatus !== '' ? params : {}));
        await dispatch(getPartsBrandForINventory(currentPageStatus !== '' ? params : {}));
    };

    const fetchAllFilterApi = async () => {
        await dispatch(getPartNumberForINventory());
        await dispatch(getTireDimensionForINventory());
        await dispatch(getSupplierListApi());
        await dispatch(getPartsCatgeoryForINventory());

        await dispatch(getTyreModelForINventory());
    };

    // Handle tab change
    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedTab = tabsOrder[newValue];

        if (selectedTab.id === 'parts') navigate('/inventory/parts');
        else if (selectedTab.id === 'tires') navigate('/inventory/tires');
        else if (selectedTab.id === 'all') navigate('/inventory/all');
    };
    // Menu handlers
    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    // Handle drag end
    const onDragEnd = (result) => {
        // Dropped outside the list
        if (!result.destination) return;

        const items = Array.from(tabsOrder);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        // Update indexes
        const updatedItems = items.map((item, index) => ({
            ...item,
            index,
        }));

        setTabsOrder(updatedItems);

        // Update the selected tab if necessary
        const currentTabId = tabsOrder[value].id;
        const newIndex = updatedItems.findIndex((tab) => tab.id === currentTabId);
        setValue(newIndex);
    };

    // Create a11y props for tabs
    const a11yProps = (index) => {
        return {
            id: `tab-${index}`,
            'aria-controls': `tabpanel-${index}`,
        };
    };
    const handleSortRequest = (key) => {
        setSortParams((prevSortParams) => {
            // Find the existing sort index
            const existingSortIndex = prevSortParams.findIndex((param) => param.key === key);

            const newSortParams = [...prevSortParams];

            if (existingSortIndex >= 0) {
                // Toggle the order if the key already exists
                const updatedSort = {
                    ...newSortParams[existingSortIndex],
                    orderBy: newSortParams[existingSortIndex].orderBy === 'ASC' ? 'DESC' : 'ASC',
                };

                // Remove from current position and add to the start
                newSortParams.splice(existingSortIndex, 1);
                newSortParams.unshift(updatedSort);
            } else {
                // Add new sort option to the top
                newSortParams.unshift({ key, orderBy: 'ASC' });
            }

            return newSortParams;
        });
    };

    const debounceSearch = useCallback(
        debounce((event) => {
            setSearchValue(event?.target?.value || '');
            setPage(0);
        }, 800),
        []
    );
    const handleResetFilter = () => {
        // const search = document.getElementById("outlined-adornment-search");
        // if (search) {
        //   search.value = "";
        // }
        setPage(0);
        setSearchValue('');
        setPartBrandArray([]);
        setTireDimensionArray([]);
        setPartCategoryArray([]);
        setTireModalArray([]);
        setSupplierArray([]);
        setSelectStatus('');

        // setSortParams(sortArray);
    };

    const onSubmitInventoryModal = async (values) => {
        setType(PART_TYPES.PARTS);
        setSelectedInventoryId(null);
    };

    const handleEditInventory = (data) => {
        if (data?.batchNumber?.length > 1) {
            setSelectedInventoryId(data?._id);
            setOpenPartDetailModal(true);
            return;
        }
        if (data?.batchNumber?.length > 0) {
            setBatchNumber(data?.batchNumber[0]);
        }
        setOpenInventoryModal(true);
        setSelectedInventoryId(data?._id);
    };

    return (
        <>
            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <Box padding={'32px 24px'} sx={{ bgcolor: 'background.main' }}>
                {/* Page header  */}
                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} rowGap={{ lg: 2 }}>
                    <Grid item lg={3.8} md={4} sm={12} xs={12} xl={5}>
                        <Typography variant="h4" sx={{ fontWeight: 400 }}>
                            Inventory
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        lg={8.2}
                        md={8}
                        xl={7}
                        sx={{
                            display: 'flex',
                            justifyContent: {
                                md: 'end',
                            },
                            flexWrap: { xs: 'wrap', sm: 'nowrap' }, // Allow wrapping on smaller screens
                            gap: 3,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            size={'large'}
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                setType(PART_TYPES.PARTS);
                                setOpenInventoryModal(true);
                            }}
                        >
                            ADD PART
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            size="large"
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                setType(PART_TYPES.TYRE);
                                setOpenInventoryModal(true);
                            }}
                        >
                            ADD TIRE
                        </Button>
                    </Grid>
                </Grid>

                {/* Tabs  */}
                <Box
                    className="supplierProfileTabs"
                    sx={{
                        borderBottom: 0,
                        borderColor: 'divider',
                        overflow: 'auto',
                        marginTop: '16px',
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="inventory tabs"
                        sx={{
                            marginBottom: '24px',
                            overflow: 'auto',
                            display: 'flex',
                        }}
                    >
                        {tabsOrder.map((tab, index) => (
                            <Tab
                                key={tab.id}
                                label={tab.label}
                                {...a11yProps(index)}
                                sx={{
                                    minWidth: tab.id === 'all' ? '58px' : tab.id === 'tires' ? '72px' : '77px',
                                }}
                            />
                        ))}
                        <IconButton onClick={handleMenuOpen}>
                            <MoreVert />
                        </IconButton>
                    </Tabs>

                    {/* Options Menu */}
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <Box sx={{ p: 1, width: '162px' }}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    paddingLeft: '4px',
                                    paddingRight: '4px',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: '#000',
                                    letterSpacing: '0.4px',
                                    mb: '8px',
                                }}
                            >
                                DRAG TO REORDER
                            </Typography>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="tabs-list">
                                    {(provided) => (
                                        <Box {...provided.droppableProps} ref={provided.innerRef}>
                                            {tabsOrder.map((tab, index) => (
                                                <Draggable key={tab.id} draggableId={tab.id} index={index}>
                                                    {(provided) => (
                                                        <MenuItem
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            sx={{
                                                                height: '38px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                padding: '0',
                                                            }}
                                                        >
                                                            <ListItemIcon sx={{ minWidth: '24px' }}>
                                                                <DragIndicator color="#2196F3" style={{ fill: '#2196F3', fontSize: 24 }} />
                                                            </ListItemIcon>
                                                            <Typography>{tab.label}</Typography>
                                                        </MenuItem>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Box>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Box>
                    </Menu>
                </Box>

                {tabIndices?.map((i) => {
                    return (
                        <CustomTabPanel value={value} key={i} index={i}>
                            {/* Filter & Search  */}
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} marginBottom={'32px'}>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    lg={8}
                                    xl={7.5}
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    rowGap={1}
                                    columnGap={2}
                                >
                                    {currentPageStatus === PART_TYPES.TYRE && (
                                        <Grid item md="auto">
                                            <Button
                                                variant={tireDimensionArray.length > 0 ? 'contained' : 'text'}
                                                id="demo-positioned-button"
                                                aria-haspopup="true"
                                                onClick={(event) => setAnchorElDimensions(event.currentTarget)}
                                                sx={{
                                                    color: tireDimensionArray.length > 0 ? 'white!important' : 'black!important',
                                                    fontWeight: 500,
                                                    lineHeight: '24px',
                                                    padding: '6px 12px!important',
                                                }}
                                                startIcon={
                                                    tireDimensionArray.length > 0 && (
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: 'white',
                                                                color: 'primary.main',
                                                                fontSize: '14px!important',
                                                                fontWeight: '500!important',
                                                                letterSpacing: '0.4px',
                                                                lineHeight: '24px',
                                                                width: 24,
                                                                height: 24,
                                                            }}
                                                        >
                                                            {tireDimensionArray.length}
                                                        </Avatar>
                                                    )
                                                }
                                                endIcon={<ExpandMore />}
                                            >
                                                DIMENSIONS
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorElDimensions}
                                                open={openDimensions}
                                                onClose={() => setAnchorElDimensions(null)}
                                                MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                }}
                                                style={{ height: '400px', width: '320px' }}
                                            >
                                                {inventoryTyreDimension?.length > 0 ? (
                                                    inventoryTyreDimension.map((data, index) => (
                                                        <MenuItem key={data?._id || index}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={tireDimensionArray.includes(data)} // Check if data.id is in the state
                                                                        onChange={() => {
                                                                            setPage(0);
                                                                            setTireDimensionArray(
                                                                                (prev) =>
                                                                                    prev.includes(data)
                                                                                        ? prev.filter((_id) => _id !== data) // Remove if already selected
                                                                                        : [...prev, data] // Add if not selected
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                label={data}
                                                            />
                                                        </MenuItem>
                                                    ))
                                                ) : (
                                                    <MenuItem>No Options</MenuItem>
                                                )}
                                            </Menu>
                                        </Grid>
                                    )}
                                    <Grid item md="auto">
                                        <Button
                                            variant={supplierArray.length > 0 ? 'contained' : 'text'}
                                            id="demo-positioned-button"
                                            aria-haspopup="true"
                                            onClick={(event) => setAnchorElSupplier(event.currentTarget)}
                                            sx={{
                                                padding: '6px 12px!important',
                                                fontWeight: 500,
                                                lineHeight: '24px',
                                                width: '100%',
                                                color: supplierArray.length > 0 ? 'white!important' : 'black!important',
                                            }}
                                            startIcon={
                                                supplierArray.length > 0 && (
                                                    <Avatar
                                                        sx={{
                                                            bgcolor: 'white',
                                                            color: 'primary.main',
                                                            fontSize: '14px!important',
                                                            fontWeight: '500!important',
                                                            letterSpacing: '0.4px',
                                                            lineHeight: '24px',
                                                            width: 24,
                                                            height: 24,
                                                        }}
                                                    >
                                                        {supplierArray.length}
                                                    </Avatar>
                                                )
                                            }
                                            endIcon={<ExpandMore />}
                                        >
                                            SUPPLIER
                                        </Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorElSupplier}
                                            open={openSupplier}
                                            onClose={() => setAnchorElSupplier(null)}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            style={{ height: '400px', width: '320px' }}
                                        >
                                            {supplierList?.length > 0 ? (
                                                supplierList.map((data, index) => (
                                                    <MenuItem key={data?._id || index}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={supplierArray.includes(data?._id)} // Check if data.id is in the state
                                                                    onChange={() => {
                                                                        setPage(0);
                                                                        setSupplierArray(
                                                                            (prev) =>
                                                                                prev.includes(data?._id)
                                                                                    ? prev.filter((_id) => _id !== data?._id) // Remove if already selected
                                                                                    : [...prev, data?._id] // Add if not selected
                                                                        );
                                                                    }}
                                                                />
                                                            }
                                                            label={data?.name}
                                                        />
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem>No Options</MenuItem>
                                            )}
                                        </Menu>
                                    </Grid>
                                    <Grid item md="auto">
                                        <Button
                                            variant={partBrandArray.length > 0 ? 'contained' : 'text'}
                                            id="demo-positioned-button"
                                            aria-haspopup="true"
                                            onClick={(event) => setAnchorElBrand(event.currentTarget)}
                                            sx={{
                                                color: partBrandArray.length > 0 ? 'white!important' : 'black!important',
                                                fontWeight: 500,
                                                lineHeight: '24px',
                                                padding: '6px 12px!important',
                                            }}
                                            startIcon={
                                                partBrandArray.length > 0 && (
                                                    <Avatar
                                                        sx={{
                                                            bgcolor: 'white',
                                                            color: 'primary.main',
                                                            fontSize: '14px!important',
                                                            fontWeight: '500!important',
                                                            letterSpacing: '0.4px',
                                                            lineHeight: '24px',
                                                            width: 24,
                                                            height: 24,
                                                        }}
                                                    >
                                                        {partBrandArray.length}
                                                    </Avatar>
                                                )
                                            }
                                            endIcon={<ExpandMore />}
                                        >
                                            BRAND
                                        </Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorElBrand}
                                            open={openBrand}
                                            onClose={() => setAnchorElBrand(null)}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            style={{ height: '400px', width: '320px' }}
                                        >
                                            {inventoryPartsBrand?.length > 0 ? (
                                                inventoryPartsBrand.map((data) => (
                                                    <MenuItem key={data.id}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={partBrandArray.includes(data?._id)} // Check if data.id is in the state
                                                                    onChange={() => {
                                                                        setPage(0);
                                                                        setPartBrandArray(
                                                                            (prev) =>
                                                                                prev.includes(data?._id)
                                                                                    ? prev.filter((_id) => _id !== data?._id) // Remove if already selected
                                                                                    : [...prev, data?._id] // Add if not selected
                                                                        );
                                                                    }}
                                                                />
                                                            }
                                                            label={data.name}
                                                        />
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem>No Options</MenuItem>
                                            )}
                                        </Menu>
                                    </Grid>

                                    {currentPageStatus !== PART_TYPES.TYRE ? (
                                        <Grid item md="auto">
                                            <Button
                                                variant={partCategoryArray.length > 0 ? 'contained' : 'text'}
                                                id="demo-positioned-button"
                                                aria-haspopup="true"
                                                onClick={(event) => setAnchorElCategory(event.currentTarget)}
                                                sx={{
                                                    color: partCategoryArray.length > 0 ? 'white!important' : 'black!important',
                                                    fontWeight: 500,
                                                    lineHeight: '24px',
                                                    padding: '6px 12px!important',
                                                }}
                                                startIcon={
                                                    partCategoryArray.length > 0 && (
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: 'white',
                                                                color: 'primary.main',
                                                                fontSize: '14px!important',
                                                                fontWeight: '500!important',
                                                                letterSpacing: '0.4px',
                                                                lineHeight: '24px',
                                                                width: 24,
                                                                height: 24,
                                                            }}
                                                        >
                                                            {partCategoryArray.length}
                                                        </Avatar>
                                                    )
                                                }
                                                endIcon={<ExpandMore />}
                                            >
                                                CATEGORY
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorElCategory}
                                                open={openCategory}
                                                onClose={() => setAnchorElCategory(null)}
                                                MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                }}
                                                style={{ height: '400px', width: '320px' }}
                                            >
                                                {inventoryPartsCategory?.length > 0 ? (
                                                    inventoryPartsCategory.map((data) => (
                                                        <MenuItem key={data.id}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={partCategoryArray.includes(data?._id)} // Check if data.id is in the state
                                                                        onChange={() => {
                                                                            setPage(0);
                                                                            setPartCategoryArray(
                                                                                (prev) =>
                                                                                    prev.includes(data?._id)
                                                                                        ? prev.filter((_id) => _id !== data?._id) // Remove if already selected
                                                                                        : [...prev, data?._id] // Add if not selected
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                label={data.name}
                                                            />
                                                        </MenuItem>
                                                    ))
                                                ) : (
                                                    <MenuItem>No Options</MenuItem>
                                                )}
                                            </Menu>
                                        </Grid>
                                    ) : (
                                        <Grid item md="auto">
                                            <Button
                                                variant={tireModalArray.length > 0 ? 'contained' : 'text'}
                                                id="demo-positioned-button"
                                                aria-haspopup="true"
                                                onClick={(event) => setAnchorElTireModal(event.currentTarget)}
                                                sx={{
                                                    color: tireModalArray.length > 0 ? 'white!important' : 'black!important',
                                                    fontWeight: 500,
                                                    lineHeight: '24px',
                                                    padding: '6px 12px!important',
                                                }}
                                                startIcon={
                                                    tireModalArray.length > 0 && (
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: 'white',
                                                                color: 'primary.main',
                                                                fontSize: '14px!important',
                                                                fontWeight: '500!important',
                                                                letterSpacing: '0.4px',
                                                                lineHeight: '24px',
                                                                width: 24,
                                                                height: 24,
                                                            }}
                                                        >
                                                            {tireModalArray.length}
                                                        </Avatar>
                                                    )
                                                }
                                                endIcon={<ExpandMore />}
                                            >
                                                Model
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorElTireModal}
                                                open={openTireModal}
                                                onClose={() => setAnchorElTireModal(null)}
                                                MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                }}
                                                style={{ height: '400px', width: '320px' }}
                                            >
                                                {inventoryTyreModel?.length > 0 ? (
                                                    inventoryTyreModel.map((data) => (
                                                        <MenuItem key={data.id}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={tireModalArray.includes(data?._id)} // Check if data.id is in the state
                                                                        onChange={() => {
                                                                            setPage(0);
                                                                            setTireModalArray(
                                                                                (prev) =>
                                                                                    prev.includes(data?._id)
                                                                                        ? prev.filter((_id) => _id !== data?._id) // Remove if already selected
                                                                                        : [...prev, data?._id] // Add if not selected
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                label={data.name}
                                                            />
                                                        </MenuItem>
                                                    ))
                                                ) : (
                                                    <MenuItem>No Options</MenuItem>
                                                )}
                                            </Menu>
                                        </Grid>
                                    )}

                                    <Grid item md="auto">
                                        <Button
                                            variant={selectStatus !== '' ? 'contained' : 'text'}
                                            id="demo-positioned-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            onClick={(event) => {
                                                setAnchorEl(event.currentTarget);
                                            }}
                                            sx={{
                                                padding: '6px 12px!important',
                                                color: selectStatus !== '' ? 'white!important' : 'black!important',
                                                fontWeight: 500,
                                                lineHeight: '24px',
                                            }}
                                            startIcon={
                                                selectStatus !== '' && (
                                                    <Avatar
                                                        sx={{
                                                            bgcolor: 'white',
                                                            color: 'primary.main',
                                                            fontSize: '14px!important',
                                                            fontWeight: '500!important',
                                                            letterSpacing: '0.4px',
                                                            lineHeight: '24px',
                                                            width: 24,
                                                            height: 24,
                                                        }}
                                                    >
                                                        {1}
                                                    </Avatar>
                                                )
                                            }
                                            endIcon={<ExpandMore />}
                                        >
                                            Availability
                                        </Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open1}
                                            onClose={() => setAnchorEl(null)}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                        >
                                            <MenuItem>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selectStatus === PARTS_STATUS.IN_STOCK}
                                                            //   name=""
                                                            onChange={(value) => {
                                                                setPage(0);
                                                                if (selectStatus === PARTS_STATUS.IN_STOCK) {
                                                                    setSelectStatus('');
                                                                } else {
                                                                    setSelectStatus(PARTS_STATUS.IN_STOCK);
                                                                }
                                                            }}
                                                        />
                                                    }
                                                    label="In Stock"
                                                />
                                            </MenuItem>
                                            <MenuItem>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selectStatus === PARTS_STATUS.OUT_OF_STOCK}
                                                            //   name=""
                                                            onChange={(value) => {
                                                                setPage(0);
                                                                if (selectStatus === PARTS_STATUS.OUT_OF_STOCK) {
                                                                    setSelectStatus('');
                                                                } else {
                                                                    setSelectStatus(PARTS_STATUS.OUT_OF_STOCK);
                                                                }
                                                            }}
                                                        />
                                                    }
                                                    label="Out of Stock"
                                                />
                                            </MenuItem>
                                        </Menu>
                                    </Grid>

                                    {showClearFilterButton && (
                                        <Grid item md="auto">
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                startIcon={<Close />}
                                                onClick={handleResetFilter}
                                                sx={{
                                                    background: '#0000001A',
                                                    color: '#000000',
                                                    '&:hover': {
                                                        background: '#0000001A',
                                                        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    },
                                                    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    fontWeight: 500,
                                                    lineHeight: '24px',
                                                }}
                                            >
                                                {clearFilterLabel}
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>

                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    mt={{ sm: 2, xs: 2, md: 0 }}
                                    md={6}
                                    lg={4} //1200
                                    xl={4.5}
                                    padding={'6px'}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-search"
                                            placeholder="Part #, part name, supplier, etc..."
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            }
                                            endAdornment={
                                                searchValue !== '' && (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => {
                                                                setSearchValue('');
                                                                const search = document.getElementById('outlined-adornment-search');
                                                                if (search) {
                                                                    search.value = '';
                                                                }
                                                            }}
                                                            edge="end"
                                                            size="small"
                                                        >
                                                            <Close fontSize="14" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }
                                            onChange={debounceSearch}
                                            label="Search"
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {/* Table  */}

                            <Grid
                                container
                                item
                                boxShadow={0}
                                borderRadius={'4px'}
                                sx={{
                                    bgcolor: 'white',
                                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
                                }}
                            >
                                <Grid item xl={12} md={12} sm={12} xs={12}>
                                    <TableContainer sx={{ maxHeight: 800 }}>
                                        <Table stickyHeader sx={{ tableLayout: 'auto' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ minWidth: '120px' }}>
                                                        <TableSortLabel
                                                            active={sortParams.some((param) => param.key === 'partNumber')}
                                                            direction={
                                                                sortParams.find((param) => param.key === 'partNumber')?.orderBy === 'ASC' ? 'asc' : 'desc'
                                                            }
                                                            sx={sortParams[0].key === 'partNumber' && activeTableSortLabel}
                                                            onClick={() => handleSortRequest('partNumber')}
                                                        >
                                                            {getCurrentPage() === PART_TYPES.TYRE ? 'Tire' : 'Part #'}
                                                        </TableSortLabel>
                                                    </TableCell>
                                                    {currentPageStatus !== PART_TYPES.TYRE ? (
                                                        <TableCell style={{ minWidth: '140px' }}>
                                                            <TableSortLabel
                                                                active={sortParams.some((param) => param.key === 'part')}
                                                                direction={sortParams.find((param) => param.key === 'part')?.orderBy === 'ASC' ? 'asc' : 'desc'}
                                                                sx={sortParams[0].key === 'part' && activeTableSortLabel}
                                                                onClick={() => handleSortRequest('part')}
                                                            >
                                                                Part Name
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell style={{ minWidth: '140px' }}>
                                                            <TableSortLabel
                                                                active={sortParams.some((param) => param.key === 'dimensions')}
                                                                direction={
                                                                    sortParams.find((param) => param.key === 'dimensions')?.orderBy === 'ASC' ? 'asc' : 'desc'
                                                                }
                                                                sx={sortParams[0].key === 'dimensions' && activeTableSortLabel}
                                                                onClick={() => handleSortRequest('dimensions')}
                                                            >
                                                                Dimensions
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    )}

                                                    <TableCell style={{ minWidth: '120px' }}>
                                                        <TableSortLabel
                                                            active={sortParams.some((param) => param.key === 'supplier')}
                                                            direction={sortParams.find((param) => param.key === 'supplier')?.orderBy === 'ASC' ? 'asc' : 'desc'}
                                                            sx={sortParams[0].key === 'supplier' && activeTableSortLabel}
                                                            onClick={() => handleSortRequest('supplier')}
                                                        >
                                                            Supplier
                                                        </TableSortLabel>
                                                    </TableCell>

                                                    <TableCell style={{ minWidth: '120px' }}>
                                                        <TableSortLabel
                                                            active={sortParams.some((param) => param.key === 'partsBrand')}
                                                            direction={
                                                                sortParams.find((param) => param.key === 'partsBrand')?.orderBy === 'ASC' ? 'asc' : 'desc'
                                                            }
                                                            sx={sortParams[0].key === 'partsBrand' && activeTableSortLabel}
                                                            onClick={() => handleSortRequest('partsBrand')}
                                                        >
                                                            Brand
                                                        </TableSortLabel>
                                                    </TableCell>

                                                    {currentPageStatus !== PART_TYPES.TYRE && (
                                                        <TableCell style={{ minWidth: '120px' }}>
                                                            <TableSortLabel
                                                                active={sortParams.some((param) => param.key === 'partsCategory')}
                                                                direction={
                                                                    sortParams.find((param) => param.key === 'partsCategory')?.orderBy === 'ASC'
                                                                        ? 'asc'
                                                                        : 'desc'
                                                                }
                                                                sx={sortParams[0].key === 'partsCategory' && activeTableSortLabel}
                                                                onClick={() => handleSortRequest('partsCategory')}
                                                            >
                                                                Category
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    )}
                                                    {currentPageStatus === PART_TYPES.TYRE && (
                                                        <TableCell style={{ minWidth: '120px' }}>
                                                            <TableSortLabel
                                                                active={sortParams.some((param) => param.key === 'tyreModel')}
                                                                direction={
                                                                    sortParams.find((param) => param.key === 'tyreModel')?.orderBy === 'ASC' ? 'asc' : 'desc'
                                                                }
                                                                sx={sortParams[0].key === 'tyreModel' && activeTableSortLabel}
                                                                onClick={() => handleSortRequest('tyreModel')}
                                                            >
                                                                Model
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    )}
                                                    <TableCell style={{ minWidth: '150px' }}>
                                                        <TableSortLabel
                                                            active={sortParams.some((param) => param.key === 'createdAt')}
                                                            direction={
                                                                sortParams.find((param) => param.key === 'createdAt')?.orderBy === 'ASC' ? 'asc' : 'desc'
                                                            }
                                                            sx={sortParams[0].key === 'createdAt' && activeTableSortLabel}
                                                            onClick={() => handleSortRequest('createdAt')}
                                                        >
                                                            Date Added
                                                        </TableSortLabel>
                                                    </TableCell>

                                                    <TableCell style={{ minWidth: '120px' }}>Cost</TableCell>
                                                    <TableCell style={{ minWidth: '120px' }}>Quantity</TableCell>

                                                    <TableCell
                                                        style={{
                                                            minWidth: '120px',
                                                            // display: 'flex',
                                                            // alignItems: 'center',
                                                            // gap: '4px',
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <span>Tracked</span>
                                                            <HtmlTooltip
                                                                placement="top"
                                                                arrow
                                                                title="Tracked parts are connected to
suppliers and supplier invoices."
                                                            >
                                                                <IconButton style={{ padding: '0' }}>
                                                                    <Info
                                                                        style={{
                                                                            fill: '#0000008F',
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </HtmlTooltip>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell style={{ minWidth: '60px', width: '60px', height: '100%' }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {inventoryList?.length === 0 && showLoader === false ? (
                                                    <TableRow style={{ borderBottom: 'none' }}>
                                                        <TableCell colSpan={8} style={{ borderBottom: 'none' }}>
                                                            <Stack
                                                                style={{
                                                                    width: '100%',
                                                                    height: 'calc(100svh - 464px)',
                                                                }}
                                                                justifyContent={'center'}
                                                                alignItems={'center'}
                                                            >
                                                                <Stack sx={{ with: '100%', maxWidth: '400px' }} justifyContent={'center'} alignItems={'center'}>
                                                                    <img
                                                                        src={emptyInventory}
                                                                        alt="empty"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            width: '200px',
                                                                            height: 'auto',
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        sx={{
                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                            fontSize: '34px',
                                                                            fontWeight: 400,
                                                                            lineHeight: '123.5%',
                                                                            letterSpacing: '0.25px',
                                                                            textAlign: 'center',
                                                                            marginBottom: '10px',
                                                                        }}
                                                                    >
                                                                        Inventory Empty
                                                                    </Typography>

                                                                    <Typography
                                                                        sx={{
                                                                            color: '#000',
                                                                            textAlign: 'center',

                                                                            fontSize: '16px',
                                                                            fontWeight: 400,
                                                                            lineHeight: '24px',
                                                                            letterSpacing: '0.15px',
                                                                        }}
                                                                    >
                                                                        {`Your inventory is empty, and you can't add parts to the invoice. To add new parts or
                                                                        tires, use the 'Add' buttons at the top right of the page.`}
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : showLoader ? (
                                                    <TableRowsLoader rowsNum={10} cellsNum={9} />
                                                ) : (
                                                    Array.isArray(inventoryList) &&
                                                    inventoryList.map((data, index) => (
                                                        <Fragment key={data._id}>
                                                            <TableRow
                                                                key={data._id}
                                                                hover={true}
                                                                onClick={() => {
                                                                    handleEditInventory(data);
                                                                    // setOpenInventoryModal(true);
                                                                    // setSelectedInventoryId(data?._id);
                                                                }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    {data.partsType === PART_TYPES.PARTS ? data?.partNumber : data?.part?.partName}
                                                                </TableCell>

                                                                <TableCell align="left">
                                                                    <Stack direction={'row'} alignItems={'center'} gap={1}>
                                                                        {data.partsType === PART_TYPES.PARTS ? (
                                                                            <div
                                                                                style={{
                                                                                    width: '23px',
                                                                                    height: '22px',
                                                                                }}
                                                                            >
                                                                                <svg
                                                                                    width="23"
                                                                                    height="22"
                                                                                    viewBox="0 0 23 22"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M15.3233 1.37501C14.4945 1.37483 13.6765 1.56193 12.9302 1.92234C12.1839 2.28274 11.5287 2.80714 11.0136 3.45634C10.4985 4.10554 10.1367 4.86275 9.95536 5.67141C9.774 6.48006 9.77773 7.31925 9.96627 8.12626L3.02114 15.3244C2.52996 15.8454 2.26306 16.5385 2.27793 17.2544C2.29281 17.9702 2.58827 18.6516 3.10068 19.1518C3.61309 19.6519 4.30145 19.9308 5.01748 19.9284C5.73351 19.9259 6.41993 19.6423 6.92889 19.1386L13.8135 12.1646C14.692 12.4147 15.6189 12.4422 16.5107 12.2445C17.4024 12.0469 18.231 11.6304 18.9216 11.0326C19.6121 10.4347 20.1431 9.67442 20.4664 8.82018C20.7898 7.96594 20.8954 7.04465 20.7738 6.13939C20.7569 6.01211 20.7047 5.89211 20.6231 5.79297C20.5415 5.69382 20.4338 5.61951 20.3122 5.57844C20.1905 5.53736 20.0598 5.53118 19.9348 5.56057C19.8099 5.58997 19.6956 5.65377 19.605 5.74476L16.6983 8.65289L13.5454 5.50001L16.4535 2.59189C16.5445 2.5013 16.6083 2.38705 16.6377 2.26207C16.6671 2.13709 16.6609 2.00637 16.6198 1.88473C16.5788 1.76309 16.5045 1.65537 16.4053 1.57379C16.3062 1.49221 16.1862 1.44002 16.0589 1.42314C15.8146 1.3906 15.5684 1.37452 15.3219 1.37501"
                                                                                        fill="#006CDD"
                                                                                    />
                                                                                </svg>
                                                                            </div>
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    width: '23px',
                                                                                    height: '22px',
                                                                                }}
                                                                            >
                                                                                <svg
                                                                                    width="23"
                                                                                    height="22"
                                                                                    viewBox="0 0 23 22"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M11.2005 3.66602C7.157 3.66602 3.86719 6.95583 3.86719 10.9994C3.86719 15.0429 7.157 18.3327 11.2005 18.3327C15.2441 18.3327 18.5339 15.0429 18.5339 10.9994C18.5339 6.95583 15.2441 3.66602 11.2005 3.66602ZM14.9523 6.40527C14.9932 6.35987 15.0428 6.32313 15.0981 6.29722C15.1535 6.27132 15.2135 6.25677 15.2745 6.25445C15.3811 6.24238 15.518 6.29429 15.6075 6.37932C16.5582 7.27943 17.2046 8.42528 17.4749 9.69285C17.5178 9.89515 17.4203 10.1011 17.2367 10.1959C16.7882 10.4278 16.2556 10.5401 15.7454 10.5401C15.0803 10.5401 14.45 10.3494 14.0848 9.98418C13.3078 9.20765 13.6318 7.86982 14.9523 6.40527ZM7.44885 15.665C7.40796 15.7105 7.35837 15.7473 7.30302 15.7733C7.24767 15.7993 7.18768 15.8139 7.12658 15.8163C7.12121 15.8168 7.11494 15.8168 7.10866 15.8168C6.99147 15.8168 6.8787 15.772 6.79357 15.6914C5.84289 14.7913 5.19655 13.6455 4.92624 12.3775C4.88327 12.1752 4.98085 11.9693 5.16437 11.8744C6.19743 11.3413 7.67087 11.4407 8.3163 12.0861C9.0924 12.8627 8.76833 14.2005 7.44885 15.665ZM8.31626 9.98423C7.95102 10.3495 7.3208 10.5402 6.65569 10.5402C6.14543 10.5402 5.6137 10.4278 5.16433 10.196C5.075 10.1498 5.00332 10.0755 4.9603 9.98466C4.91727 9.89377 4.90529 9.79126 4.9262 9.6929C5.19655 8.42532 5.84285 7.27947 6.79353 6.37936C6.88303 6.29433 7.01465 6.24152 7.12654 6.2545C7.18761 6.25683 7.24759 6.27137 7.30294 6.29728C7.35829 6.32318 7.40789 6.35992 7.4488 6.40532C8.76923 7.86982 9.09326 9.20765 8.31626 9.98423ZM13.1538 17.1112C12.5191 17.3135 11.862 17.4161 11.2005 17.4161C10.539 17.4161 9.88191 17.3136 9.24726 17.1112C9.04582 17.0468 8.91425 16.8534 8.92856 16.6426C9.04316 14.9932 10.0198 13.7494 11.2005 13.7494C12.3813 13.7494 13.3579 14.9932 13.4725 16.6426C13.4794 16.7451 13.4518 16.8469 13.394 16.9319C13.3362 17.0168 13.2517 17.08 13.1538 17.1112ZM9.36719 10.9994C9.36719 9.98827 10.1899 9.16602 11.2005 9.16602C12.2112 9.16602 13.0339 9.98822 13.0339 10.9994C13.0339 12.0105 12.2112 12.8327 11.2005 12.8327C10.1899 12.8327 9.36719 12.0105 9.36719 10.9994ZM13.4725 5.39237C13.3579 7.0413 12.3813 8.28516 11.2005 8.28516C10.0198 8.28516 9.04316 7.0413 8.92856 5.39237C8.91425 5.18157 9.04492 4.98821 9.24636 4.92418C10.5176 4.51865 11.8835 4.51865 13.1547 4.92418C13.3561 4.98821 13.4868 5.18157 13.4725 5.39237ZM17.4749 12.3045C17.2045 13.5725 16.5582 14.7184 15.6075 15.6185C15.5224 15.6991 15.4096 15.7439 15.2924 15.7438C15.2862 15.7438 15.2799 15.7438 15.2745 15.7434C15.2135 15.7411 15.1535 15.7265 15.0981 15.7006C15.0428 15.6747 14.9932 15.638 14.9523 15.5926C13.6319 14.1281 13.3078 12.7898 14.0848 12.0132C14.7302 11.3673 16.2028 11.2693 17.2367 11.8015C17.3261 11.8477 17.3977 11.9219 17.4408 12.0128C17.4838 12.1037 17.4958 12.2062 17.4749 12.3045Z"
                                                                                        fill="#006CDD"
                                                                                    />
                                                                                    <path
                                                                                        d="M11.1992 0C5.13345 0 0.199219 4.9347 0.199219 11C0.199219 17.0653 5.13345 22 11.1992 22C17.265 22 22.1992 17.0653 22.1992 11C22.1992 4.9347 17.265 0 11.1992 0ZM11.1992 19.25C6.6499 19.25 2.94922 15.5489 2.94922 11C2.94922 6.45111 6.6499 2.75 11.1992 2.75C15.7485 2.75 19.4492 6.45111 19.4492 11C19.4492 15.5489 15.7485 19.25 11.1992 19.25Z"
                                                                                        fill="#006CDD"
                                                                                    />
                                                                                </svg>
                                                                            </div>
                                                                        )}
                                                                        {data.partsType === PART_TYPES.PARTS ? data?.part?.partName : data.tyreDimension}
                                                                    </Stack>
                                                                </TableCell>
                                                                <TableCell align="left">{data?.supplier?.name}</TableCell>

                                                                <TableCell align="left">{data?.partsBrand?.name}</TableCell>

                                                                {currentPageStatus !== PART_TYPES.TYRE ? (
                                                                    <TableCell align="left">{data?.partsCategory?.name || data?.tyreModel?.name}</TableCell>
                                                                ) : (
                                                                    <TableCell align="left">{data?.tyreModel?.name}</TableCell>
                                                                )}
                                                                <TableCell align="left">
                                                                    {data?.createdAt ? dayjs(data?.createdAt).format('DD MMM YYYY') : '-'}
                                                                </TableCell>

                                                                <TableCell align="left">
                                                                    {data?.batchNumber?.length > 1
                                                                        ? '-'
                                                                        : NumericEngine.format(data?.lastCost || 0, {
                                                                              formatCurrency: true,
                                                                              trailingZeros: true,
                                                                          })}
                                                                </TableCell>
                                                                <TableCell align="left">{data?.inStock}</TableCell>

                                                                <TableCell
                                                                    align="left"
                                                                    style={{
                                                                        letterSpacing: '0..17px',
                                                                    }}
                                                                >
                                                                    <Chip
                                                                        label={
                                                                            data?.isTracked
                                                                                ? capitalize(INVENTORY_STATUS.TRACKED)
                                                                                : capitalize(INVENTORY_STATUS.UNTRACKED)
                                                                        }
                                                                        style={{
                                                                            color: '#000000DE',
                                                                            fontSize: '13px',
                                                                            fontWeight: '500',
                                                                            lineHeight: '18px',
                                                                            letterSpacing: '0.16px',
                                                                            background: data?.isTracked
                                                                                ? INVENTORY_STATUS.COLORS.TRACKED
                                                                                : INVENTORY_STATUS.COLORS.UNTRACKED,
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Stack
                                                                        direction={'row'}
                                                                        gap={'0'}
                                                                        // justifyContent={"flex-end"}
                                                                    >
                                                                        {data?.batchNumber?.length > 1 &&
                                                                        (data.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED || !data?.inventoryType) ? (
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={() => {
                                                                                    setSelectedInventoryId(data?._id);
                                                                                    setOpenPartDetailModal(true);
                                                                                }}
                                                                            >
                                                                                <Visibility
                                                                                    style={{
                                                                                        color: '#646466',
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        ) : (
                                                                            <>
                                                                                {data.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED ||
                                                                                !data?.inventoryType ? (
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => {
                                                                                            handleEditInventory(data);
                                                                                        }}
                                                                                    >
                                                                                        <Edit
                                                                                            style={{
                                                                                                color: '#646466',
                                                                                            }}
                                                                                        />
                                                                                    </IconButton>
                                                                                ) : (
                                                                                    <></>
                                                                                )}

                                                                                <IconButton
                                                                                    color="error"
                                                                                    size="small"
                                                                                    onClick={(event) => {
                                                                                        event.stopPropagation();
                                                                                        event.preventDefault();
                                                                                        setInventoryDetail(data);
                                                                                        setSelectedInventoryId(data?._id);
                                                                                        setShowDeleteModal(true);

                                                                                        setCustomerInvoices(data?.customerInvoices);
                                                                                    }}
                                                                                >
                                                                                    <Delete color="error" />
                                                                                </IconButton>
                                                                            </>
                                                                        )}
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        </Fragment>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {inventoryList?.length === 0 && showLoader === false ? (
                                        <></>
                                    ) : showLoader ? (
                                        ''
                                    ) : (
                                        <Grid container alignItems={'center'} justifyContent="end">
                                            <Grid item>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                                    colSpan={3}
                                                    count={totalCount}
                                                    rowsPerPage={rowsPerPage}
                                                    style={{ border: 'none' }}
                                                    page={page}
                                                    slotProps={{
                                                        select: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        actions: {
                                                            showFirstButton: true,
                                                            showLastButton: true,
                                                        },
                                                    }}
                                                    onRowsPerPageChange={(event) => setRowsPerPage(Number.parseInt(event.target.value, 10))}
                                                    onPageChange={(event, newPage) => setPage(newPage)}
                                                    className="pagination-right"
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </CustomTabPanel>
                    );
                })}
            </Box>

            {/* Add Inventory  */}
            {openInventoryModel && (
                <AddInventoryModal
                    isAddPartBtn
                    isAddPartAgain={isAddPartAgain}
                    setIsAddPartAgain={setIsAddPartAgain}
                    type={INVENTORY_TYPES.INVENTORY}
                    partType={type}
                    inventoryId={selectedInventoryId}
                    batchNumber={batchNumber}
                    openModal={openInventoryModel}
                    closeModal={() => {
                        setType(PART_TYPES.PARTS);
                        setOpenInventoryModal(false);
                        setBatchNumber(null);
                        setSelectedInventoryId(null);
                    }}
                    onSubmitModal={onSubmitInventoryModal}
                    hideTabs
                    setShowLoader={setShowLoader}
                    showLoader={showLoader}
                    fetchApi={() => {
                        if (isAddPartAgain) {
                            setTimeout(() => {
                                setSelectedInventoryId(null);
                                setOpenInventoryModal(true);
                            }, 300);

                            return;
                        }
                        fetchInventory();
                        fetchAllFilterApi();
                        fetchApiWithTabChange();
                    }}
                    ShowAllTabs={false}
                    ShowTabIndex={0}
                    modalType="add"
                />
            )}
            {openPartDetailModal && (
                <PartDetailsModal
                    open={openPartDetailModal}
                    onClose={() => {
                        setOpenPartDetailModal(false);
                        setSelectedInventoryId(null);
                    }}
                    inventoryId={selectedInventoryId}
                    fetchApi={() => {}}
                />
            )}

            {partInvoiceModal && (
                <PartUsedInvoiceModal
                    open={partInvoiceModal}
                    batchNumber={batchNumber || inventoryDetail?.batchNumber[0]}
                    onClose={() => {
                        setPartInvoiceModal(false);
                    }}
                    invoiceData={customerInvoices}
                />
            )}

            <CommonDialog
                loader={isDeleting}
                open={showDeleteModal}
                onClose={() => {
                    setInventoryDetail(null);
                    setSelectedInventoryId(null);
                    setShowDeleteModal(false);
                }}
                onSave={async () => {
                    let resp;
                    if (inventoryDetail?.isUsedInCustomerInvoice) {
                        setPartInvoiceModal(true);
                        return;
                    }
                    setIsDeleting(true);
                    if (!inventoryDetail?.isTracked) {
                        resp = await deleteInventoryApi(
                            inventoryDetail?._id,
                            inventoryDetail?.batchNumber?.length > 0 ? inventoryDetail?.batchNumber[0] : null
                        );
                    } else if (inventoryDetail?.supplierInvoice?.length > 0 && inventoryDetail?.supplierInvoice[0]?._id) {
                        navigate(
                            `/suppliers-invoice/${
                                inventoryDetail?.supplierInvoice[0]?.paymentStatus === 'open'
                                    ? 'open'
                                    : inventoryDetail?.supplierInvoice[0]?.paymentStatus === 'partial_payment'
                                      ? 'partial'
                                      : 'paid'
                            }/` + inventoryDetail?.supplierInvoice[0]?._id
                        );
                    }
                    if (resp) {
                        setInventoryDetail(null);
                        setSelectedInventoryId(null);
                        setShowDeleteModal(false);
                        fetchInventory();
                    }
                    setIsDeleting(false);
                }}
                dialogClaassName={
                    inventoryDetail?.isUsedInCustomerInvoice
                        ? 'commonDialog commonDialog__600'
                        : !inventoryDetail?.isTracked
                          ? 'commonDialog'
                          : 'commonDialog commonDialog__600'
                }
                dialogTitle={
                    inventoryDetail?.isUsedInCustomerInvoice
                        ? '🚫 Cannot Delete Inventory'
                        : !inventoryDetail?.isTracked
                          ? 'Delete Part?'
                          : '⚠️ Part added from Supplier Invoice'
                }
                dialogSubtitle={
                    inventoryDetail?.isUsedInCustomerInvoice
                        ? 'This part has been used in at least one customer invoice.'
                        : !inventoryDetail?.isTracked
                          ? 'Are you sure you want to delete this part from your inventory?'
                          : 'This part was originally added through a Supplier Invoice.'
                }
                dialogSubtitle2={
                    inventoryDetail?.isUsedInCustomerInvoice
                        ? 'To preserve invoice history, deletion is not allowed. To hide this part, click View In-Stock Parts Only.'
                        : !inventoryDetail?.isTracked
                          ? ''
                          : 'To maintain accurate inventory and costing, please delete it directly from the Supplier Invoice.'
                }
                saveButtonText={
                    inventoryDetail?.isUsedInCustomerInvoice
                        ? `view Invoice${customerInvoices.length > 1 ? 's' : ''}`
                        : !inventoryDetail?.isTracked
                          ? 'Delete'
                          : 'view supplier Invoice'
                }
                saveButtonType={inventoryDetail?.isUsedInCustomerInvoice ? 'primary' : !inventoryDetail?.isTracked ? 'error' : 'primary'}
                saveButtonWidth={inventoryDetail?.isUsedInCustomerInvoice ? '148px' : !inventoryDetail?.isTracked ? '103px' : '210px'}
            />
        </>
    );
};

export default Inventory;
